import asyncStorage from 'localforage'





const storageKey = 'device'

function attemptGetLegacyToken() {
    let potentialToken = null
    
    try {
        potentialToken = JSON.parse(window.localStorage.getItem(storageKey))
    } catch (error) {}

    return potentialToken
}

export async function getDeviceToken(isFirstLoad) {
    // This is to be backwards compatible with the current experience so we don't
    // lose track of existing tokens
    if (isFirstLoad) {
        const legacyToken = attemptGetLegacyToken()
        if (legacyToken) {
            window.localStorage.removeItem(storageKey)
            asyncStorage.setItem(storageKey, legacyToken)
            return legacyToken
        }
    }

    let currentToken = await asyncStorage.getItem(storageKey)

    if (!currentToken) {
        currentToken = (window.crypto.getRandomValues(new Uint32Array(1))[0]).toString(16)
        asyncStorage.setItem(storageKey, currentToken)
    }

    return currentToken
}